import { ReactNode, createContext, useContext } from 'react';

import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';

import { ValueOf } from 'lib/core/types';

export interface ISoftphoneModalOptionsProps {
  title?: string;
  subtitle?: string;
  content: ReactNode;
  invertButtonOrder?: boolean;
  onSave?: () => void;
  onDelete?: () => void;
  onSecondary?: () => void;
  closeDisabled?: boolean;
  saveDisabled?: boolean;
  secondaryDisabled?: boolean;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  deleteButtonText?: string;
  secondaryButtonIcon?: IconDefinition;
  secondaryAsyncAction?: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
  id?: string;
  onCancel?: () => void;
  hideSecondaryButton?: boolean;
  syncAction?: boolean;
  customHeader?: ReactNode;
}

interface ISoftphoneModalContext {
  state: {
    isModalOpen: boolean;
  };
  actions: {
    openModal: (options?: ISoftphoneModalOptionsProps) => void;
    closeModal: () => void;
    updateModalOptions: (value: Partial<ISoftphoneModalOptionsProps>) => void;
    updateChildProps: (props: any) => void;
  };
}

const Context = createContext<ISoftphoneModalContext>({
  state: {
    isModalOpen: false,
  },
  actions: {
    openModal: () => void 0,
    closeModal: () => void 0,
    updateModalOptions: () => void 0,
    updateChildProps: () => {},
  },
});

export default Context;

// export the context hook
export const useSoftphoneModalContext = () => useContext(Context);
